interface Props {
  title: string
  caption?: string
  right?: React.ReactNode
}

export default function PageHeader({ title, caption, right }: Props) {
  return (
    <header style={{
      padding: '14px 16px 18px',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 12,
    }}>
      <div style={{ minWidth: 0 }}>
        <h1 className="page-title">{title}</h1>
        {caption && <div className="page-caption">{caption}</div>}
      </div>
      {right}
    </header>
  )
}
